import { usePage } from "PFApp/use_page";
import { ApiRoute } from "PFCore/utilities/routes";
import { useEffect } from "react";

export const useChangeRequestView = (initPage, { changeRequestId }) => {
  const { page, setPage, mergePage, resetPage } = usePage(`change_request`, initPage);

  const fetchChangeRequest = (changeRequestId) => {
    $.ajax({
      url: ApiRoute(`/api/change_requests/${changeRequestId}`),
      api_version: 2
    })
      .then((response) =>
        mergePage({
          loaded: true,
          changeRequest: response
        })
      )
      .catch(() =>
        mergePage({
          loaded: true,
          errors: ["there was an error"]
        })
      );
  };

  useEffect(() => {
    setPage(initPage);
    return resetPage;
  }, []);

  useEffect(() => {
    fetchChangeRequest(changeRequestId);
  }, []);

  return { ...page };
};
